import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import ErrorAdd from "../../../util/ErrorAdd";

function BlockNotificationsItem({ maxExist }) {

    const [list, setList] = useState([]);
    const [notifData, setNotifData] = useState([]);
    //const [integrationTelegram, setIntegrationTelegram] = useState(false);

    const stateSetting = useSelector((state) => state.setting);//Настройки

    /*useEffect(() => {
        if (stateSetting.user !== null) {
            setIntegrationTelegram(stateSetting.user.Integration_Telegram);
        }
    }, [stateSetting.user]);*/

    useEffect(() => {
        loadList();
    }, []);

    function loadList() {
        axios.get('/api_tracker/notification/listByUser', { params: { ID_Service: 2 } })
            .then((res) => {
                if (res.data.Status === 1) {
                    var notifData_ = [];

                    res.data.Data.map(item => {
                        if (notifData_.filter(a => a.ID_Notification === item.ID_Notification).length === 0) {
                            notifData_.push({ ID_Notification: item.ID_Notification, Name: item.Name });
                        }
                    })

                    setNotifData(notifData_);
                    setList(res.data.Data)
                }
                else {

                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }

    function chackedHandler(Val, ID_Notification, ID_Channel) {
        axios.post('/api_tracker/notification/userSet', { ID_Notification: ID_Notification, ID_Channel: ID_Channel, Disabled: !Val })
            .then((res) => {
                if (res.data.Status === 1) {
                    var notifData_ = [];

                    res.Data.map(item => {
                        if (notifData_.filter(a => a.ID_Notification === item.ID_Notification).length === 0) {
                            notifData_.push({ ID_Notification: item.ID_Notification, Name: item.Name });
                        }
                    })

                    setNotifData(notifData_);
                    setList(res.Data)
                }
                else {

                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="d-flex bd-highlight">
                    <div className="p-1 flex-grow-1 bd-highlight">
                        <div className="form-label"></div>
                    </div>
                    <div className="p-1 bd-highlight" style={{ width: "75px", textAlign: "center" }}>
                        Email
                    </div>
                    <div className="p-1 bd-highlight" style={{ width: "75px", textAlign: "center" }}>
                        Max Bot
                    </div>
                </div>
                {notifData.map(item => (
                    <div key={item.ID_Notification} className="d-flex bd-highlight row_select">
                        <div className="p-1 flex-grow-1 bd-highlight">
                            <div className="form-label">{item.Name}</div>
                        </div>
                        <div className="p-1 bd-highlight" style={{ width: "75px", textAlign: "center" }}>
                            <div className="form-check_ form-switch p-0" >
                                <div className="d-inline-flex flex-row-reverse gap-1">
                                    <input defaultChecked={!list.filter(a => a.ID_Notification === item.ID_Notification & a.ID_Channel === 1)[0].Disabled} className="form-check-input ms-0" type="checkbox" role="switch" onChange={(e) => chackedHandler(e.target.checked, item.ID_Notification, 1)} /*disabled={disabled}*/ />
                                </div>
                            </div>
                        </div>
                        <div className="p-1 bd-highlight" style={{ width: "75px", textAlign: "center" }}>
                            <div className="form-check_ form-switch p-0" >
                                <div className="d-inline-flex flex-row-reverse gap-1">
                                    <input defaultChecked={!list.filter(a => a.ID_Notification === item.ID_Notification & a.ID_Channel === 3)[0].Disabled} className="form-check-input ms-0" type="checkbox" role="switch" onChange={(e) => chackedHandler(e.target.checked, item.ID_Notification, 3)} disabled={!maxExist} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default BlockNotificationsItem;